/**
 * A/B bucket for pages with an active experiment. Fastly assigns the bucket on the visitor's first request, sets
 * it in the `ab_bucket` cookie and forwards it as `X-AB-Bucket`; the origin only reads it. The site writes the
 * cookie only when a visitor declines A/B cookies, switching them to `control` (persistBucket.ts). No header
 * means no bucket was assigned (no Fastly, e.g. local dev): the visitor gets the original and isn't counted. A
 * page that renders an experiment must send `Vary: X-AB-Bucket` so Fastly caches one copy per bucket (and one for
 * "no bucket"). The origin never sets the cookie — a Set-Cookie here would land on a cached, shared response.
 */
import type { IncomingMessage, ServerResponse } from 'node:http';

export type Bucket = 'treatment' | 'control';

export function bucketForExperiment(req: IncomingMessage, res: ServerResponse): Bucket | null {
  res.appendHeader('Vary', 'X-AB-Bucket');
  return readBucket(req);
}

export function readBucket(req: IncomingMessage): Bucket | null {
  const value = req.headers['x-ab-bucket'];
  return isBucket(value) ? value : null;
}

export function isBucket(value: unknown): value is Bucket {
  return value === 'treatment' || value === 'control';
}
